import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductGroupCreateComponent } from './product-group-create.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ProductGroupCreateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ProductGroupCreateComponent]
})
export class ProductGroupCreateModule { }
